import 'normalize.css';
import '@progress/kendo-theme-material/dist/all.css';
import '@kcftech/design-tokens/primitives.css';
import '@kcftech/design-system/theme.css';
import 'styles/tokens/semantics.css';
import 'styles/global.css';
import 'styles/imports.scss';
import './sentry-instrument';

import { App } from 'App';
import { Auth } from 'auth-provider';
import { createRoot } from 'react-dom/client';
import { Environment } from 'utils/EnvironmentHelper';

import { initPendo } from './init/pendo';
import { init } from './test/server';

initPendo();

Auth.configure({
    // REQUIRED - Amazon Cognito Region
    region: 'us-east-1',
    userPoolId: Environment.cognito.UserPoolId,
    userPoolWebClientId: Environment.cognito.ClientId,
    mandatorySignIn: true,
    oauth: {
        domain: Environment.cognito.Domain,
        scope: ['profile', 'openid'],
        redirectSignIn: `${window.origin}/`,
        redirectSignOut: `${window.origin}/login`,
        responseType: 'code',
    },
});

init().then(() => {
    const container = document.getElementById('root');
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const root = createRoot(container!);
    root.render(<App />);
});
